'use client';

import React from 'react';

const PagerIndicator = ({ 
  totalPages = 3, 
  currentPage = 0, 
  onPageChange,
  className = '',
  ...props
}) => {
  return (
    <div data-component-id="src/components/ui/PagerIndicator.jsx:13:4" data-component-path="src/components/ui/PagerIndicator.jsx" data-component-line="13" data-component-file="PagerIndicator.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" className={`flex flex-row gap-x-4 ${className}`} {...props}>
      {Array.from({ length: totalPages }, (_, index) => (
        <div data-component-id="src/components/ui/PagerIndicator.jsx:15:8" data-component-path="src/components/ui/PagerIndicator.jsx" data-component-line="15" data-component-file="PagerIndicator.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          key={index}
          className={`
            w-5
            h-5
            rounded-lg
            cursor-pointer
            transition-colors
            duration-200
            ${index === currentPage ? 'bg-pager-1' : 'bg-pager-2'}
          `.trim().replace(/\s+/g, ' ')}
          onClick={() => onPageChange && onPageChange(index)}
        />
      ))}
    </div>
  );
};

export default PagerIndicator;